import type { CabUpdateResponse } from '@/api';
import { CabInfo } from './cab-info';
import { DriverInfo } from './driver-info';

interface CabDriverDetailsProps extends CabUpdateResponse {}

export function CabDriverDetails(props: CabDriverDetailsProps) {
	const { cab, driver } = props;

	return (
		<div className="flex gap-2.5 items-start justify-start relative w-full">
			{cab && <CabInfo cab={cab} />}
			{driver && <DriverInfo driver={driver} />}
		</div>
	);
}
